import { Avatar, Box, IconButton, Menu, Toolbar, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

import logo from '@/assets/logo.svg';
import izziLogo from '@/assets/izzi-logo.png';
import { useAuth0Generic } from '@/hooks/auth';
import { stringAvatar, stringToColor } from '@/utils/strings';

import { AppBar as genAppBar } from '../dependencies';
import { ProfileMenuOptions } from './ProfileMenuOptions';
import TopMenu from './TopMenu';
import useLayout from './useLayout';

const drawerWidth = 250;

const AppBar = genAppBar(drawerWidth);

export default function DashboardTopLayout(props: PropsWithChildren) {
  const { handle_el, handleOpenUserMenu, handleCloseUserMenu } = useLayout();

  const { name } = useAuth0Generic();
  return (
    <div className="flex h-full flex-col">
      <AppBar
        color="inherit"
        position="relative"
        elevation={0}
        variant="outlined"
        sx={{ borderLeft: 'none', borderTop: 'none', flexShrink: 0 }}
      >
        <Toolbar>
          <div className="flex items-center gap-3">
            <img src={logo} style={{ maxHeight: 38 }} alt="99Minutos logo" />
            <div className="h-8 w-px bg-gray-300" aria-hidden="true" />
            <img src={izziLogo} style={{ maxHeight: 38 }} alt="Izzi logo" />
          </div>

          <Box sx={{ marginLeft: 2, marginRight: 'auto' }} className="top-menu">
            <TopMenu />
          </Box>
          {name && (
            <>
              <Typography
                noWrap
                fontWeight="bold"
                color="primary"
                component="div"
                sx={{ marginRight: 1 }}
              >
                {name}
              </Typography>
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  color="primary"
                  sx={{
                    bgcolor: stringToColor(name || ''),
                  }}
                >
                  {stringAvatar(name || '')}
                </Avatar>
              </IconButton>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={handle_el}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={!!handle_el}
                onClose={handleCloseUserMenu}
              >
                <ProfileMenuOptions closeMenu={handleCloseUserMenu} />
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
      <div className="min-h-0 flex-1 overflow-y-auto bg-gray-50">
        <main className="relative w-full">{props.children}</main>
      </div>
    </div>
  );
}
